module.exports = __webpack_public_path__ + "static/media/tenor.9b9415b1.gif";